var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWpfLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wpf:like",
    clipPath: "url(#clip0_108_231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.4513 13.2998C36.8571 14.5308 33.8088 18.8574 32.2569 21.693C29.4951 20.0132 24.7007 17.7881 20.1087 19.0185C12.1937 21.1393 8.14619 28.137 10.2623 36.0344C12.594 44.7363 20.9639 48.5218 29.0609 52.1832C32.8843 53.9144 36.8401 55.7018 40.1173 57.9811C40.6681 58.3621 41.3582 58.4826 42.0026 58.3099L42.1297 58.2758C42.7764 58.1026 43.311 57.6516 43.5959 57.049C45.2987 53.4353 47.8281 49.9079 50.2764 46.4985C55.4564 39.282 60.8165 31.8174 58.4843 23.1134C56.3682 15.2159 49.3641 11.1795 41.4513 13.2998Z",
    fill: "#DA4D67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white",
    transform: "translate(0 15.2703) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpfLike);
export default __webpack_public_path__ + "static/media/wpf_like.055f5c95e7110b679aa4c4422e745a7f.svg";
export { ForwardRef as ReactComponent };